import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import TraitRisk from 'on_web/components/shared/TraitRisk/TraitRisk';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Button from 'on_web/components/shared/Common/Button';
import BloodTypeAssessmentCard from '../BloodTypeAssessmentCard/BloodTypeAssessmentCard';

/**
 * Component displaying trait chart section.
 * @param {Component properties} props
 */
export default function ReportsTraitChartSection(props) {
  const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
      fontFamily: 'Museo-500',
      fontSize: '18px',
      lineHeight: 1.22,
      color: '#ffffff',
    },
    allTraitsTile: {
      fontFamily: 'MuseoSans-500',
      fontSize: 16,
      lineHeight: 1.19,
      color: '#2a343f',
    },
  }));

  const classes = useStyles();

  return (
    <Box mx={'5px'} my={'20px'} justifyContent="center" display="flex">
      <Box justifyContent="center" display="flex" style={{ marginLeft: '8px' }}>
        {props.showLeftArrow ? (
          <Button
            startIcon={<ArrowBackIosIcon />}
            variant="text"
            onClick={props.onClickLeft}
            color="inherit"
            style={{ minWidth: '40px' }}
          ></Button>
        ) : props.replaceLeftArrow ? (
          <div style={{ minWidth: '40px' }} />
        ) : (
          <React.Fragment />
        )}
      </Box>
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="center"
        style={{ maxWidth: props.maxWidth }}
      >
        <Box
          className={classes.allTraitsTile}
          style={{
            textAlign: 'center',
          }}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <div
            style={{
              maxWidth: '250px',
            }}
          >
            <span>{props.title}</span>
          </div>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center">
          {!props.type ? (
            <TraitRisk
              riskLevel={props.risk}
              riskLabel={props.riskLevel}
              width={250}
            />
          ) : (
            <BloodTypeAssessmentCard
              isDesktop={props.isDesktop}
              riskLevel={props.risk}
              type={props.type}
              typeDescription={props.riskLevel[0]}
              riskDescription={props.riskLevel[1]}
            />
          )}
        </Box>
      </Grid>
      <Box display="flex" justifyContent="center" alignItems="center">
        {props.showRightArrow ? (
          <Button
            startIcon={<ArrowForwardIosIcon />}
            variant="text"
            onClick={props.onClickRight}
            color="inherit"
            style={{ minWidth: '40px', textAlign: 'center' }}
          ></Button>
        ) : props.replaceRightArrow ? (
          <div style={{ minWidth: '40px' }} />
        ) : (
          <React.Fragment />
        )}
      </Box>
    </Box>
  );
}
